import * as actions from './certificacao.action';
import inicialState from './certificacao.state';

const certificacaoReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.SHOW_MODAL_CERTIFICACAO:
      return {
        ...state,
        showModal: action.payload.showModal,
    };
    case actions.SELECIONAR_CERTIFICADOS:
      return {
        ...state,
        certificadosSelecionados: action.payload.certificadosSelecionados,
    };
    case actions.TOTAL_CERTIFICADOS_EXIBIDOS:
      return {
        ...state,
        listaExibido: action.payload.listaExibido,
    };

    case actions.TOTAL_CERTIFICADOS_PENDENTES:
      return {
        ...state,
        totalPendentes: action.payload.totalPendentes,
    };

    case actions.LISTA_CERTIFICADOS_PENDENTES:
      return {
        ...state,
        listaPendentes: action.payload.listaPendentes,
    };

    case actions.ATUALIZAR_PAGINA_CERTIFICADOS:
      return {
        ...state,
        pagina: action.payload.pagina,
    };

    default:
      return state;
  }
};

export default certificacaoReducer;



// WEBPACK FOOTER //
// ./src/app/common/certificacao/certificacao.reducer.js